<template>
  <div>
    <v-chip label x-small :color="getColorWithLighten(params.status)" :text-color="getColorWithDarken(params.status)"
      class="font-weight-bold px-2">
      {{ params.status }}
    </v-chip>
  </div>
</template>

<script>
export default {
  methods: {
    getColorWithLighten(status) {
      const normalizedStatus = status?.toLowerCase();

      const statusColors = {
        'success': 'green lighten-4',
        'verified': 'green lighten-4',
        'active': 'green lighten-4',

        'inprogress': 'orange lighten-4',
        'on trip': 'orange lighten-4',

        'pending': 'yellow lighten-4',
        'idle': 'yellow lighten-4',

        'no data': 'blue-grey lighten-4',
        'inactive': 'grey lighten-3',
        'deactivated': 'grey lighten-3',
        'detached': 'grey lighten-3',

        'leave': 'blue lighten-4',
        'on leave': 'blue lighten-4',

        'error': 'red lighten-4',
        'failed': 'red lighten-4',
        'rejected': 'red lighten-4'
      };

      if (statusColors[normalizedStatus]) {
        return statusColors[normalizedStatus];
      }

      const colorKey = this.$globals?.getColorKey(status);
      if (colorKey) {
        return `${colorKey.replace("--text", "")} lighten-4`;
      }

      // Default color
      return "grey lighten-4";
    },

    getColorWithDarken(status) {
      const normalizedStatus = status?.toLowerCase();

      const statusTextColors = {
        'success': 'green darken-4',
        'verified': 'teal darken-4',
        'active': 'light-green darken-4',

        'inprogress': 'deep-purple darken-2',
        'on trip': 'indigo darken-3',

        'pending': 'amber darken-4',
        'idle': 'orange darken-3',

        'no data': 'blue-grey darken-2',
        'inactive': 'blue-grey darken-2',
        'deactivated': 'grey darken-3',
        'detached': 'brown darken-3',

        'leave': 'cyan darken-3',
        'on leave': 'light-blue darken-3',

        'error': 'red darken-4',
        'failed': 'deep-orange darken-4',
        'rejected': 'pink darken-4'
      };

      if (statusTextColors[normalizedStatus]) {
        return statusTextColors[normalizedStatus];
      }
      const colorKey = this.$globals?.getColorKey(status);
      if (colorKey) {
        return `${colorKey.replace("--text", "")} darken-3`;
      }

      return "grey darken-3";
    },
  },
};
</script>

<style scoped>
.v-chip {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.v-chip:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(0, 0, 0, 0.2);
}

.v-chip::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), transparent);
  border-radius: inherit;
  pointer-events: none;
}

@keyframes subtle-pulse {

  0%,
  100% {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  }

  50% {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  }
}

.v-chip.active-status {
  animation: subtle-pulse 3s ease-in-out infinite;
}
</style>